export const advances = {
  'advances.title': 'السُّلف',
  'advances.subtitle': 'طلب ← موافقة ← صرف ← خصم من الراتب',
  'advances.new': 'طلب سلفة',
  'advances.count': 'عدد السُّلف: {n}',
  'advances.filter': 'حالة السلفة',
  'advances.filter.open': 'المفتوحة',
  'advances.filter.PENDING': 'بانتظار الموافقة',
  'advances.filter.closed': 'المغلقة',
  'advances.filter.all': 'الكل',
  'advances.col.staff': 'الموظف',
  'advances.col.amount': 'المبلغ',
  'advances.col.outstanding': 'المتبقي',
  'advances.col.next': 'القسط القادم',
  'advances.col.progress': 'التقدّم',
  'advances.progress': '{percent} مسدَّد',
  'advances.requestedAmount': 'طُلب {amount} على {n}',
  'advances.empty': 'لا سُلف في هذا التصنيف',
  'advances.emptyBody': 'تُسجَّل طلبات السلف هنا مع حدّ الاستقطاع القانوني لكل موظف.',
  'advances.totalOutstanding': 'المتبقي على السُّلف المفتوحة {amount}',
  'advances.request.title': 'طلب سلفة',
  'advances.request.titleFor': 'طلب سلفة · {name}',
  'advances.request.subtitle': 'لا فوائد على السُّلف. يظهر الحد القانوني للاستقطاع الشهري قبل الإرسال.',
  'advances.request.staff': 'الموظف',
  'advances.request.months': 'عدد الأشهر',
  'advances.request.monthsHint': 'من شهر واحد حتى {max} شهراً',
  'advances.request.submit': 'إرسال الطلب',
  'advances.request.done': 'أُرسل طلب السلفة للموافقة',
  'advances.request.overCapNote': 'يمكنك الإرسال، لكن الموافقة تتطلب مدة أطول أو مبلغاً أقل.',
  'advances.calc.title': 'حاسبة السلفة',
  'advances.calc.prompt': 'اختر الموظف وأدخل المبلغ لرؤية القسط والحد القانوني.',
  'advances.calc.monthly': 'القسط الشهري',
  'advances.calc.cap': 'الحد القانوني {amount} ({rate})',
  'advances.calc.barLabel': 'القسط {monthly} من المتاح {available}',
  'advances.calc.otherAdvances': 'أقساط سُلف أخرى {amount}',
  'advances.calc.thisInstallment': 'قسط هذه السلفة',
  'advances.calc.available': 'المتاح {amount}',
  'advances.calc.wage': 'الأجر الشهري',
  'advances.calc.plan': 'الأقساط',
  'advances.calc.firstDeduction': 'أول خصم',
  'advances.calc.over': 'القسط يتجاوز الحد القانوني. أقل مدة ممكنة: {n}.',
  'advances.calc.noRoom': 'لا مجال للاستقطاع: الحد القانوني مستنفد بأقساط أخرى.',
  'advances.calc.useMonths': 'اعتماد مدة {n}',
  'advances.calc.rule.IQ': 'حد الاستقطاع في العراق ٢٠٪ من الأجر، أو ٣٠٪ إذا تجاوز الأجر ثلاثة أضعاف الحد الأدنى. لا فوائد على السُّلف.',
  'advances.calc.rule.LY': 'حد الاستقطاع في ليبيا ربع الأجر لسداد ديون جهة العمل (القانون 12 لسنة 2010، م 50). لا فوائد على السُّلف.',
  'advances.detail.title': 'سلفة · {name}',
  'advances.detail.requested': 'المبلغ المطلوب',
  'advances.detail.approved': 'المبلغ المعتمد',
  'advances.detail.monthsValue': '{n}',
  'advances.detail.startMonth': 'أول خصم',
  'advances.detail.decisionNote': 'ملاحظة القرار',
  'advances.detail.repaid': 'المسدَّد',
  'advances.detail.outstanding': 'المتبقي',
  'advances.detail.requestedOn': 'تاريخ الطلب',
  'advances.detail.staffLink': 'ملف الموظف',
  'advances.detail.steps': 'مسار الطلب — لا أحد يوافق على طلبه',
  'advances.step.request': 'الطلب',
  'advances.step.approval': 'موافقة المدير',
  'advances.step.payout': 'الصرف من الصندوق',
  'advances.step.deduction': 'الخصم من الراتب',
  'advances.step.rejected': 'رُفض الطلب',
  'advances.step.cancelled': 'أُلغي الطلب',
  'advances.step.byYou': 'بواسطتك',
  'advances.step.waiting': 'بانتظار هذه الخطوة',
  'advances.step.deductionProgress': '{paid} من {total} مسدَّد',
  'advances.step.settled': 'سُدّدت بالكامل',
  'advances.step.writtenOff': 'شُطب المتبقي بموافقة المالك',
  'advances.decide.title': 'القرار',
  'advances.decide.ownRequest': 'قدّمت هذا الطلب بنفسك، لذلك يقرّره مدير آخر أو المالك.',
  'advances.decide.mode.asRequested': 'كما طُلبت',
  'advances.decide.mode.modified': 'بتعديل',
  'advances.decide.mode.reject': 'رفض',
  'advances.decide.mode': 'نوع القرار',
  'advances.decide.amount': 'المبلغ المعتمد',
  'advances.decide.amountHint': 'حتى المبلغ المطلوب {amount}',
  'advances.decide.startMonth': 'أول شهر للخصم',
  'advances.decide.note': 'ملاحظة',
  'advances.decide.approve': 'الموافقة على {n}',
  'advances.decide.reject': 'رفض الطلب',
  'advances.decide.approved': 'وُوفق على السلفة',
  'advances.decide.rejected': 'رُفض الطلب',
  'advances.decide.capExceeded': 'القسط الشهري {monthly} يتجاوز المتاح {available}. أقل مدة ممكنة: {n}.',
  'advances.decide.moreThanRequested': 'لا يمكن اعتماد أكثر من المطلوب',
  'advances.decide.waiting': 'بانتظار موافقة المدير أو المالك',
  'advances.payout.title': 'صرف السلفة',
  'advances.payout.button': 'تسجيل الصرف',
  'advances.payout.body': 'يُسجَّل خروج {amount} من الحساب المختار اليوم.',
  'advances.payout.method': 'طريقة الصرف',
  'advances.payout.account': 'من حساب',
  'advances.payout.done': 'سُجّل صرف السلفة',
  'advances.payout.sodNotice': 'وافقت على هذه السلفة، لذا يسجّل صرفها المحاسب أو شخص آخر (فصل المهام).',
  'advances.payout.waiting': 'بانتظار تسجيل الصرف من المحاسب',
  'advances.cancel.button': 'إلغاء الطلب',
  'advances.cancel.title': 'إلغاء طلب السلفة؟',
  'advances.cancel.body': 'يُلغى الطلب وخطة الأقساط إن وُجدت، ولا يمكن التراجع.',
  'advances.cancel.done': 'أُلغي الطلب',
  'advances.repay.button': 'سداد نقدي',
  'advances.repay.title': 'سداد نقدي خارج الراتب',
  'advances.repay.body': 'المتبقي {amount}. تُخفَّض الأقساط الأخيرة بقيمة المبلغ.',
  'advances.repay.account': 'إلى الصندوق',
  'advances.repay.done': 'سُجّل السداد',
  'advances.repay.full': 'كامل المتبقي',
  'advances.writeOff.button': 'شطب المتبقي',
  'advances.writeOff.title': 'شطب المتبقي من السلفة؟',
  'advances.writeOff.body': 'يُشطب {amount} وتُغلق السلفة. للمالك فقط، ويبقى في سجل التدقيق.',
  'advances.writeOff.done': 'شُطب المتبقي',
  'advances.installments.title': 'خطة الأقساط',
  'advances.installments.planned': 'المخطط',
  'advances.installments.deducted': 'المخصوم',
  'advances.installments.empty': 'تُنشأ الخطة عند الموافقة',
  'advances.installmentStatus.PLANNED': 'مخطط',
  'advances.installmentStatus.DEDUCTED': 'خُصم',
  'advances.installmentStatus.PARTIAL': 'خُصم جزئياً · رُحّل الباقي',
  'advances.installmentStatus.SKIPPED': 'مؤجَّل',
  'advances.skip.button': 'تأجيل',
  'advances.skip.title': 'تأجيل قسط {month}؟',
  'advances.skip.body': 'يُنقل المبلغ إلى ما بعد آخر قسط.',
  'advances.skip.done': 'أُجّل القسط',
  'advances.repayments.title': 'السدادات',
  'advances.repayments.empty': 'لا سدادات بعد',
  'advances.repaymentSource.PAYROLL': 'من الراتب',
  'advances.repaymentSource.CASH': 'نقداً',
  'advances.repaymentSource.FINAL_SETTLEMENT': 'التسوية النهائية',
  'advances.repaymentSource.WRITE_OFF': 'شطب',
  'advances.decide.ownerOnly': 'سلفة المدير يقرّرها المالك، لا مدير آخر.',
  'advances.detail.overMonths': '{amount} على {n}',
  'advances.opening.button': 'سلفة من قبل تباشير',
  'advances.opening.title': 'سلفة من قبل تباشير',
  'advances.opening.body': 'سلفة صُرفت قبل استخدام تباشير وما زالت تُستقطع من الراتب. لا تُسجَّل حركة في الصندوق.',
  'advances.opening.amount': 'المتبقي منها',
  'advances.opening.monthly': 'القسط الشهري',
  'advances.opening.monthlyHint': 'كما يُستقطع الآن. اتركه فارغاً لأقصر مدة ضمن الحد القانوني.',
  'advances.opening.startMonth': 'أول شهر يُستقطع فيه',
  'advances.opening.note': 'ملاحظة',
  'advances.opening.save': 'حفظ السلفة',
  'advances.opening.done': 'أُدخلت السلفة',
  'advances.opening.badge': 'من قبل تباشير',
  'advances.opening.notice': 'سلفة من قبل استخدام تباشير: لم تُصرف من صندوق هنا، وتُستقطع من الرواتب كغيرها.',
  'advances.opening.owed': 'المتبقي عند بدء تباشير',
  'advances.opening.enteredOn': 'تاريخ الإدخال',
  'advances.opening.undo': 'إلغاء السلفة',
  'advances.opening.undoTitle': 'إلغاء السلفة المُدخلة؟',
  'advances.opening.undoBody': 'للسلفة المُدخلة خطأً: تُحذف هي وخطة أقساطها. لا يمكن ذلك بعد أن يُستقطع منها شيء أو يدخل قسطها في مسيّر رواتب.',
  'advances.opening.undone': 'أُلغيت السلفة',
  'advances.step.opening': 'أُدخلت سلفةً من قبل تباشير',
} as const;
